import heroLab from '../images/hero-lab.png';
// All mock content for Pharmacy College Azamgarh landing page
export const college = {
  name: 'Pharmacy College',
  location: 'Azamgarh',
  since: 'Since 1999',
  logo: 'https://customer-assets.emergentagent.com/job_77e78621-d633-4489-850f-eadbb87fd760/artifacts/uopxkyqe_435703006_8224679757545335_1887701012457006530_n.jpg',
  address: 'Itaura, Chandeshwar, Azamgarh, Uttar Pradesh 276128, India',
  phone: '+91 9839296340',
  phoneClean: '919839296340',
  email: 'info@pharmacycollegeazamgarh.edu.in',
  website: 'https://aicceds.org',
  rating: 3.9,
  reviews: 273,
  approvals: 'Approved by PCI · Affiliated to AKTU Lucknow',
};

export const heroStats = [
  { value: '26+', label: 'Years of Excellence' },
  { value: '3000+', label: 'Alumni Network' },
  { value: '100%', label: 'PCI Approved' },
  { value: 'Yes', label: 'AKTU Affiliated' },
];

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Courses', href: '#courses' },
  { label: 'Admissions', href: '#admissions' },
  { label: 'Facilities', href: '#facilities' },
  { label: 'Placements', href: '#placements' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
];

export const features = [
  { icon: 'BadgeCheck', title: 'PCI Approved', desc: 'Nationally recognized programs approved by the Pharmacy Council of India.' },
  { icon: 'GraduationCap', title: 'Experienced Faculty', desc: 'Learn from PhD-qualified professors with decades of industry expertise.' },
  { icon: 'FlaskConical', title: 'Modern Laboratories', desc: 'State-of-the-art labs equipped with the latest pharmaceutical instruments.' },
  { icon: 'Briefcase', title: 'Training & Placement', desc: 'Dedicated placement cell ensuring careers at top pharma companies.' },
  { icon: 'Factory', title: 'Industry Visits', desc: 'Regular visits to leading pharmaceutical manufacturing units.' },
  { icon: 'Microscope', title: 'Research Labs', desc: 'Advanced research facilities for innovation and publications.' },
  { icon: 'Award', title: 'Scholarships', desc: 'Merit and need-based scholarships for deserving students.' },
  { icon: 'BookOpen', title: 'Library', desc: 'Well-stocked digital and physical library with over 15,000 books.' },
  { icon: 'Building2', title: 'Campus Facilities', desc: 'Modern hostel, sports complex, cafeteria, and Wi-Fi campus.' },
];

export const courses = [
  {
    tag: 'PCI Approved | AKTU Affiliated',
    code: 'B.Pharm',
    title: 'Bachelor of Pharmacy',
    desc: 'A comprehensive undergraduate program preparing students for careers in pharmaceutical industry, research, and clinical practice.',
    duration: '4 Years',
    seats: '60',
    level: 'UG',
    eligibility: '10+2 Science (PCM / PCB) with minimum 50% marks',
    highlights: [
      '8 Semesters with industry internship',
      'Clinical & industrial training',
      'Research project in final year',
      '100% placement assistance',
    ],
  },
  {
    tag: 'PCI Approved | BTE Lucknow',
    code: 'D.Pharm',
    title: 'Diploma in Pharmacy',
    desc: 'A diploma program focused on the practical aspects of pharmacy practice for retail and hospital pharmacy careers.',
    duration: '2 Years',
    seats: '60',
    level: 'Diploma',
    eligibility: '10+2 Science with minimum 45% marks',
    highlights: [
      '500-hour practical training',
      'Community pharmacy exposure',
      'Registered Pharmacist eligibility',
      'Hospital training included',
    ],
  },
];

export const whyChoose = [
  { num: '01', title: 'Excellent Faculty', desc: 'Highly qualified PhD faculty with strong industry connections and research background.' },
  { num: '02', title: 'Advanced Laboratories', desc: 'Well-equipped laboratories for pharmaceutics, pharmacology, pharmacognosy & analysis.' },
  { num: '03', title: 'Strong Alumni Network', desc: '3000+ alumni working in top pharma companies across India and abroad.' },
  { num: '04', title: 'Placement Assistance', desc: 'Dedicated placement cell with 90%+ placement track record year over year.' },
  { num: '05', title: 'Clinical Training', desc: 'Hands-on clinical training at partner hospitals and healthcare institutions.' },
  { num: '06', title: 'Industrial Visits', desc: "Regular exposure visits to Cipla, Sun Pharma, Dr. Reddy's and other units." },
  { num: '07', title: 'Research Opportunities', desc: 'Encouragement and support for student research projects and publications.' },
  { num: '08', title: 'B.Pharm Lateral Entry', desc: 'View details of students admitted through B.Pharm lateral entry.' },
];

export const admissionSteps = [
  { num: '01', title: 'Apply Online', desc: 'Fill the online admission form with your details.', icon: 'FileEdit' },
  { num: '02', title: 'Upload Documents', desc: 'Submit your 10+2 marksheet and required documents.', icon: 'Upload' },
  { num: '03', title: 'Counselling', desc: 'Attend counselling with our admission expert.', icon: 'MessageSquare' },
  { num: '04', title: 'Fee Submission', desc: 'Pay the semester fee through secure online payment.', icon: 'CreditCard' },
  { num: '05', title: 'Admission Confirmed', desc: 'Receive your admission letter and welcome kit.', icon: 'CheckCircle2' },
];

export const galleryItems = [
  { src: 'https://images.pexels.com/photos/8533087/pexels-photo-8533087.jpeg', label: 'Pharmaceutics Lab', cat: 'Labs' },
  { src: 'https://images.unsplash.com/photo-1576495199011-eb94736d05d6', label: 'Main Campus Building', cat: 'Campus' },
  { src: 'https://images.pexels.com/photos/8940480/pexels-photo-8940480.jpeg', label: 'Analytical Chemistry Lab', cat: 'Labs' },
  { src: 'https://images.unsplash.com/photo-1509062522246-3755977927d7', label: 'Smart Classroom', cat: 'Classrooms' },
  { src: 'https://images.unsplash.com/photo-1553448539-f6063db586a4', label: 'Central Library', cat: 'Library' },
  { src: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f', label: 'Convocation 2024', cat: 'Events' },
];

export const galleryTabs = ['All', 'Campus', 'Labs', 'Classrooms', 'Library', 'Events', 'Students'];

export const placementStats = [
  { value: '₹4.2 LPA', label: 'Average Package' },
  { value: '₹9.5 LPA', label: 'Highest Package' },
  { value: '92%', label: 'Placement Rate' },
  { value: '50+', label: 'Recruiting Companies' },
];

export const recruiters = [
  'Cipla', 'Sun Pharma', "Dr. Reddy's", 'Lupin', 'Cadila', 'Aurobindo',
  'Torrent Pharma', 'Alkem', 'Glenmark', 'Biocon', 'Mankind', 'Apollo Hospitals',
];

export const testimonials = [
  { id: 't-ankit-verma', initials: 'AV', name: 'Ankit Verma', role: 'B.Pharm Alumni, 2022', company: 'Sun Pharma', quote: 'The faculty at PCA shaped my career. Their industry connections helped me land my dream job at Sun Pharma right after graduation.' },
  { id: 't-priya-singh', initials: 'PS', name: 'Priya Singh', role: 'D.Pharm Alumni, 2023', company: 'Apollo Pharmacy', quote: 'Excellent practical training and personal mentorship. I feel prepared for the pharmacy profession from day one.' },
  { id: 't-rahul-yadav', initials: 'RY', name: 'Rahul Yadav', role: 'Current B.Pharm Student', company: '3rd Year', quote: 'The labs are top-notch and faculty guidance is exceptional. Loving my journey at PCA.' },
  { id: 't-sunita-devi', initials: 'SD', name: 'Mrs. Sunita Devi', role: 'Parent', company: 'Guardian of B.Pharm Student', quote: 'Safe campus, disciplined environment, and quality education. My daughter is in great hands here.' },
];

export const faqs = [
  { id: 'faq-admission-process', q: 'What is the admission process for B.Pharm and D.Pharm?', a: 'Fill out our online admission form, upload your 10+2 marksheet & documents, attend a brief counselling session with our expert, submit the semester fee online, and receive your admission letter along with a welcome kit.' },
  { id: 'faq-pci-approved', q: 'Is Pharmacy College Azamgarh PCI approved?', a: 'Yes. Our B.Pharm program is approved by the Pharmacy Council of India (PCI) and affiliated to AKTU Lucknow. D.Pharm is approved by PCI and BTE Lucknow.' },
  { id: 'faq-fees', q: 'What are the fees for B.Pharm and D.Pharm?', a: 'Fees are transparent and revised annually. Please contact our admissions office at +91 9839296340 or fill the enquiry form for the latest fee structure and available scholarships.' },
  { id: 'faq-hostel', q: 'Do you provide hostel facilities?', a: 'Yes, we offer separate hostels for boys and girls with 24/7 security, Wi-Fi, hygienic mess, and dedicated wardens. Rooms are available on twin-sharing and triple-sharing basis.' },
  { id: 'faq-placements', q: 'What placement support is available?', a: 'Our dedicated Training & Placement Cell provides career counselling, resume workshops, mock interviews, and direct campus drives with 50+ recruiters including Cipla, Sun Pharma, Dr. Reddy\'s and Apollo Hospitals.' },
  { id: 'faq-scholarships', q: 'Are scholarships available?', a: 'Yes, we offer merit-based scholarships, need-based financial aid, and special scholarships for girl students and SC/ST/OBC candidates as per government norms.' },
];

export const socialLinks = [
  { id: 'sl-facebook', label: 'Facebook', icon: 'Facebook', href: '#' },
  { id: 'sl-instagram', label: 'Instagram', icon: 'Instagram', href: '#' },
  { id: 'sl-youtube', label: 'YouTube', icon: 'Youtube', href: '#' },
  { id: 'sl-linkedin', label: 'LinkedIn', icon: 'Linkedin', href: '#' },
];

export const programLinks = [
  { id: 'p-bpharm', label: 'B.Pharm (Bachelor of Pharmacy)', href: '#courses' },
  { id: 'p-dpharm', label: 'D.Pharm (Diploma in Pharmacy)', href: '#courses' },
  { id: 'p-placements', label: 'Training & Placements', href: '#placements' },
  { id: 'p-facilities', label: 'Campus Facilities', href: '#facilities' },
];

export const legalLinks = [
  { id: 'l-privacy', label: 'Privacy Policy', href: '#' },
  { id: 'l-terms', label: 'Terms of Service', href: '#' },
  { id: 'l-sitemap', label: 'Sitemap', href: '#' },
];

export const heroImage = heroLab;